import { MatrixEvent, Room, RoomEvent } from 'matrix-js-sdk';
import { useEffect, useState } from 'react';
import { BpMatrixClient } from 'utils/matrixClient';

export const useMatrixRoomMessages = (room?: Room | null) => {
  const [messages, setMessages] = useState<MatrixEvent[]>([]);

  useEffect(() => {
    let active = true; // To prevent setting state on unmounted component

    BpMatrixClient.instance().then((fetchedClient) => {
      if (active && fetchedClient) {
        const onTimeLineEvent = async () => {
          const currentClient = await BpMatrixClient.instance();
          if (!currentClient) return {};

          const newMessages = room
            ?.getLiveTimeline()
            .getEvents()
            .filter(
              // filter redaction aka deleted  events
              (m) => m.getUnsigned()?.redacted_because?.type !== 'm.room.redaction',
            );

          setMessages(newMessages ?? []);
        };

        onTimeLineEvent();

        fetchedClient.on(RoomEvent.Timeline, onTimeLineEvent);
        fetchedClient.on(RoomEvent.Redaction, onTimeLineEvent);

        // Cleanup function to remove listeners
        return () => {
          active = false;
          fetchedClient.removeListener(RoomEvent.Timeline, onTimeLineEvent);
          fetchedClient.removeListener(RoomEvent.Redaction, onTimeLineEvent);
        };
      }
    });

    return () => {
      active = false; // Prevent setting state if component unmounts before promise resolves
    };
  }, [room]);

  return messages;
};
